import { COMPACT_ROW } from '@/components/documents/DocumentRow'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'

/** Excel's own column names: A to Z, then AA, AB… */
export function columnName(index: number): string {
  let name = ''
  for (let n = index + 1; n > 0; n = Math.floor((n - 1) / 26)) {
    name = String.fromCharCode(65 + ((n - 1) % 26)) + name
  }
  return name
}

/** A sheet's cells under Excel's column letters and row numbers, so no row is taken for a header. */
export function SheetTable({ rows }: { rows: string[][] }) {
  const width = rows[0]?.length ?? 0

  return (
    <div className="min-h-0 flex-1 overflow-y-auto rounded-sm border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-10" />
            {Array.from({ length: width }, (_, col) => (
              <TableHead key={col} className="text-ink-500 font-normal">
                {columnName(col)}
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {rows.map((row, index) => (
            <TableRow key={index} className={COMPACT_ROW}>
              <TableCell className="text-ink-500 w-10 text-right tabular-nums">{index + 1}</TableCell>
              {row.map((cell, col) => (
                <TableCell key={col} className="whitespace-nowrap">
                  {cell}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  )
}
